var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"spin"}},[(_vm.isShow)?_c('a-spin',{attrs:{"tip":"正在加载","size":"large","indicator":_vm.indicator}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }